import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	searchJiraAdmin: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchJiraAdmin: {
		id: 'directory-base-v3.header.search-jira-admin',
		defaultMessage: 'Search Jira admin',
		description: 'Label for the action selector for Jira admin',
	},
});
export default messages;
